export default __webpack_public_path__ + "static/media/logoClarito.6727be0b.png";